export const ENV_PROPERTIES = 'env-properties'
